"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Drawer = void 0;
Object.defineProperty(exports, "DrawerHeader", {
  enumerable: true,
  get: function get() {
    return _drawerHeader["default"];
  }
});
exports.sidesEnum = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _buttons = require("../../fuse-buttons/src/buttons");
var _drawerDialogue = _interopRequireDefault(require("./drawer-dialogue"));
var _drawerHeader = _interopRequireDefault(require("./drawer-header"));
var _excluded = ["children", "title", "backCallback", "closeCallback", "dataTestId", "hasBackButton", "promotionalArea", "onClose", "open", "stickyDrawer", "slidePosition", "srLabelBackButton", "srLabelCloseButton", "zIndex"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var forwardRef = _react["default"].forwardRef;
var sidesEnum = exports.sidesEnum = Object.freeze({
  left: 'left',
  right: 'right',
  top: 'top',
  bottom: 'bottom'
});
var propTypes = {
  children: _propTypes["default"].node.isRequired,
  title: _propTypes["default"].string.isRequired,
  backCallback: _propTypes["default"].func,
  closeCallback: _propTypes["default"].func,
  dataTestId: _propTypes["default"].string,
  hasBackButton: _propTypes["default"].bool,
  promotionalArea: _propTypes["default"].node,
  onClose: _propTypes["default"].func,
  open: _propTypes["default"].bool,
  stickyDrawer: _propTypes["default"].shape({
    container: _propTypes["default"].shape({
      className: _propTypes["default"].string,
      dataTestId: _propTypes["default"].string,
      open: _propTypes["default"].bool,
      transition: _propTypes["default"].string,
      zIndex: _propTypes["default"].string
    }),
    button: _propTypes["default"].element
  }),
  slidePosition: _propTypes["default"].oneOf([sidesEnum.bottom, sidesEnum.top, sidesEnum.left, sidesEnum.right]),
  srLabelBackButton: _propTypes["default"].string,
  srLabelCloseButton: _propTypes["default"].string,
  zIndex: _propTypes["default"].string
};
var defaultProps = {
  backCallback: function backCallback() {},
  closeCallback: function closeCallback() {},
  dataTestId: null,
  hasBackButton: false,
  promotionalArea: undefined,
  onClose: function onClose() {},
  open: false,
  stickyDrawer: {
    container: {
      className: 'fuse-drawer__sticky-drawer',
      dataTestId: 'fuse-drawer-sticky-drawer-data-testid',
      open: false,
      transition: '200ms',
      zIndex: '1'
    },
    button: /*#__PURE__*/_react["default"].createElement(_buttons.Button, null)
  },
  slidePosition: sidesEnum.right,
  srLabelBackButton: undefined,
  srLabelCloseButton: undefined,
  zIndex: '1'
};
var Drawer = exports.Drawer = forwardRef(function (_ref, ref) {
  var children = _ref.children,
    title = _ref.title,
    backCallback = _ref.backCallback,
    closeCallback = _ref.closeCallback,
    dataTestId = _ref.dataTestId,
    hasBackButton = _ref.hasBackButton,
    promotionalArea = _ref.promotionalArea,
    onClose = _ref.onClose,
    open = _ref.open,
    stickyDrawer = _ref.stickyDrawer,
    slidePosition = _ref.slidePosition,
    srLabelBackButton = _ref.srLabelBackButton,
    srLabelCloseButton = _ref.srLabelCloseButton,
    zIndex = _ref.zIndex,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_drawerDialogue["default"], _extends({
    title: title,
    backCallback: backCallback,
    closeCallback: closeCallback,
    dataTestId: dataTestId,
    hasBackButton: hasBackButton,
    onClose: onClose,
    open: open,
    stickyDrawer: stickyDrawer,
    promotionalArea: promotionalArea,
    ref: ref,
    slidePosition: slidePosition,
    srLabelBackButton: srLabelBackButton,
    srLabelCloseButton: srLabelCloseButton,
    zIndex: zIndex
  }, rest), children);
});
Drawer.propTypes = propTypes;
Drawer.defaultProps = defaultProps;